import { faFacebookF, faFacebookMessenger, faInstagram, faTiktok, faTwitter, faYoutube } from "@fortawesome/free-brands-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Col, Container, Row } from "react-bootstrap";
import { Link } from "react-router-dom";


const currentYear = new Date().getFullYear();


function Footer ({style}) {
    return (
        <>

            <footer className={`footer ${style ? 'dark-mode' : ""}`}>
                <Container>
                    <Row>
                        <Col lg={12}>
                        <div className="img-logo">
                            <img src="/images/logo-dark.png" />
                        </div>
                        <div className="wrapper d-flex justify-content-center align-items-center mt-3 pt-3">
             
               <div className="button">
            <div className="icon">
            <FontAwesomeIcon icon={faFacebookF} />
            </div>
            <Link to="https://www.facebook.com/mohamedhafez25" target="_blank">
               <span>Facebook</span>
               </Link>
         </div>
              
       
         
      
        <div className="button">
            <div className="icon">
            <FontAwesomeIcon icon={faYoutube} />
            </div>
          
        <Link to="https://www.youtube.com/@MrMohamedHafezofficial" target="_blank">
        <span className>YouTube</span>
        </Link>
         </div>
      
        <div className="button">
            <div className="icon">
            <FontAwesomeIcon icon={faInstagram} />
            </div>
          
        <Link to="https://www.instagram.com/mr.mohamedhafez?igsh=Y2ZxOTBrYTc3N254" target="_blank">
        <span className>Instagram</span>
        </Link>
         </div>
        {/* <div className="button">
            <div className="icon">
            <FontAwesomeIcon icon={faTiktok} />
            </div>
          
        <Link to="https://www.tiktok.com/@elfalky.2025?_t=ZS-8y2CoFwmD0U&_r=1" target="_blank">
        <span className>Tiktok</span>
        </Link>
         </div> */}

        {/* <div className="button">
            <div className="icon">
            <FontAwesomeIcon icon={faFacebookMessenger} />
            </div>
          

         </div> */}
        
                      </div>
                      <h1>اللهم إنا نسألك علماَ نافعاَ ورزقاَ طيباَ وعملاَ متقبلاَ</h1>
                      <div className="develop text-center mt-5  mb-5 pb-3">
                        <span>Developed by</span> <Link to="https://www.facebook.com/said.sayed.3386"  target="_blank" alt="">Said</Link> , <Link to="https://www.facebook.com/ahmed.abdelhamidnassef" target="_blank" alt="">Nassef</Link> <span>All Copy Rights Reserved &copy; {currentYear}</span>
                      </div>
                        </Col>
                    </Row>
                   
                </Container>
            </footer>
        </>
    )
}


export default Footer;